import { render, staticRenderFns } from "./GrupoRotaPage.vue?vue&type=template&id=ed851afc"
import script from "./GrupoRotaPage.vue?vue&type=script&lang=js"
export * from "./GrupoRotaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports